/* eslint-disable import/prefer-default-export */
import { Button } from '@constellation/core';
import styled from 'styled-components';

export const StyledButton = styled<typeof Button>(Button)`
  width: auto !important;
`;

export const StyledImgContainer = styled.div`
  ${({ theme }: any) => theme.cssPrefix} {
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: ${({ theme }: any) => theme.spacing_03};
  }
`;
